import React from 'react';
import styles from './tips.module.scss';
const Tips = props => {
  if (!props.children) return null;
  return <span className={[styles.wording, 'errorTip'].join(' ')}>{props.children}</span>;
};

export default Tips;
